import React from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  Grid,
  Paper,
  Stack,
} from "@mui/material";
import { formatAmount } from "../../utils/formatAmount";
import { CheckCircle } from "lucide-react";
import { useDpDisplayOverride } from "../../../hooks/useDpDisplayOverride";

export default function EmiBreakdown({ emiResult }) {
  const { emi } = useDpDisplayOverride(emiResult);

  const emiData = [
    {
      label: "Daily EMI",
      value: emi.daily,
      background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
      color: "#1976d2",
    },
    {
      label: "Weekly EMI",
      value: emi.weekly,
      background: "linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)",
      color: "#7b1fa2",
    },
    {
      label: "Monthly EMI",
      value: emi.monthly,
      background: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)",
      color: "#388e3c",
    },
  ];

  return (
    <Stack spacing={3}>
      <Card
        elevation={8}
        sx={{ bgcolor: "#ffffff", boxShadow: "none", borderRadius: "16px" }}
      >
        <CardContent sx={{ p: 4 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 3,
            }}
          >
            <CheckCircle style={{ fontSize: 28 }} />
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              EMI Breakdown
            </Typography>
          </Box>

          <Grid container spacing={2}>
            {emiData.map((emi, index) => (
              <Grid item xs={12} sm={4} key={index}>
                <Paper
                  sx={{
                    p: 2,
                    textAlign: "center",
                    background: emi.background,
                    boxShadow: "none",
                    borderRadius: "16px",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{ display: "block", mb: 1, fontWeight: "bold" }}
                  >
                    {emi.label}
                  </Typography>
                  <Typography
                    sx={{
                      color: emi.color,
                      fontWeight: "bold",
                      fontSize: "1.5rem",
                    }}
                  >
                    {formatAmount(emi.value)}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Stack>
  );
}
